import React from "react";
import css from "./NameCell.module.css";
// an MCL cell is a flex row, so a name followed by badges must share one block or each shrinks to a letter
export var NameCell = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: css.nameCell }, children));
};
